define.alias("shared/helpers/moment-format", "preview-grid/helpers/moment-format");